// removed by extract-text-webpack-plugin
module.exports = {"root":"_3ys6cAOY7rls8XfrPvPvIX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/file-button.scss
// module id = 1174
// module chunks = 0